import React, { useContext, useState } from "react";
import { number, string, bool, date, func } from "prop-types";
import moment from "moment";
import { transactionStatus } from "pages/transactions/constants";
import { TransactionInfo, TransactionSign } from "pages/_components/TransactionCard";
import FormattedDate from "pages/_components/FormattedDate";
import FormattedAmount from "pages/_components/FormattedAmount";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import * as i18n from "util/i18n";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import { resizableRoute as resizableComponent } from "pages/_components/Resizable";
import { types } from "../constants";

const AgreementSummary = ({ title, ...props }) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {} } = transaction;
    const { account = {} } = data;
    const { isTicket, showMoreData, setShowMoreData, isDesktop } = props;
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");

    const {
        owner = props.owner,
        expirationDate = props.expirationDate,
        purpose = props.purpose,
        tax = props.tax,
        commission = props.commission,
    } = data;

    let { amount = props.amount, currency = props.currency } = data;

    const { productType = props.productType, number: _number = props.number } = account;

    const { currency: amountCurrency, quantity } = amount;
    if (amountCurrency !== undefined) {
        amount = quantity;
        currency = amountCurrency;
    }
    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };

    const tagType =
        // eslint-disable-next-line no-nested-ternary
        transaction.idTransactionStatus === transactionStatus.FINISHED
            ? "tag-success"
            : transaction.idTransactionStatus === transactionStatus.FAILED ||
              transaction.idTransactionStatus === transactionStatus.CANCELLED
            ? "tag-error"
            : "tag-warning";

    if (isTicket) {
        return (
            <div className="ticket account-pending">
                <div className="ticket__wrapper">
                    {/* <div className="ticket__header" /> */}
                    <div className="ticket__body">
                        <div className="ticket-header-info">
                            <TransactionInfo field="account.agreement.account" withoutSpace>
                                {i18n.get(`accounts.productType.${types[productType]}`)} Nº ····
                                {_number?.slice(-4)}
                            </TransactionInfo>
                            <TransactionInfo
                                className={`amount tag ${tagType}`}
                                field="account.agreement.toRequest"
                                value={<FormattedAmount currency={currency} quantity={amount} />}
                                withoutSpace
                            />
                        </div>

                        <div className="view-more-data-button no-print">
                            <div className="ticket__divider inside-ticket__body">
                                <div className="ticket__notch ticket__notch--left"> </div>
                                <div className="ticket__notch ticket__notch--right"> </div>
                            </div>
                            <Button
                                aria-expanded={showMoreData ? "true" : "false"}
                                className="more-button"
                                label={buttonLabel}
                                bsStyle="link"
                                onClick={handleSeeMoreData}
                                image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                            />
                        </div>
                        <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                            <TransactionInfo field="accounts.agreements.owner" value={`${owner}`} />
                            <TransactionInfo
                                field="account.agreement.currency"
                                i18nId={`account.agreement.currency.${currency}`}
                                withoutSpace
                            />
                            <TransactionInfo
                                field="account.agreement.purposes"
                                i18nId={`account.agreement.purposes.${purpose}`}
                                withoutSpace
                            />
                            <TransactionInfo field="account.agreement.expirationDay" withoutSpace>
                                <FormattedDate
                                    date={
                                        typeof expirationDate !== Number
                                            ? moment(expirationDate)
                                            : moment(new Date()).add(expirationDate, "days")
                                    }
                                    dateFormat="DD/MM/YYYY"
                                />
                            </TransactionInfo>
                            <TransactionInfo field="account.agreement.originationFee" value={`${commission} %`} />
                            <TransactionInfo field="account.agreement.ratePercentage" value={`${tax} %`} withoutSpace />
                            <TransactionSign
                                creationTime
                                isSmall
                                showSignaturesInPending
                                isDesktop={isDesktop}
                                showMoreData={showMoreData}
                                noDate
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <>
            <GridTable className="deposit-summary form-summary">
                <GridTable.Container>
                    <GridTable.Data className="agreement-amount">
                        <TransactionInfo
                            field="account.agreement.toRequest"
                            value={<FormattedAmount currency={currency} quantity={amount} />}
                            withoutSpace
                        />
                    </GridTable.Data>
                    <GridTable.Data className="agreement-origin">
                        <TransactionInfo field="account.agreement.account" withoutSpace>
                            {i18n.get(`accounts.productType.${types[productType]}`)} Nº ····
                            {_number?.slice(-4)}
                        </TransactionInfo>
                    </GridTable.Data>
                    <GridTable.Data className="agreement-currency">
                        <TransactionInfo
                            field="account.agreement.currency"
                            i18nId={`account.agreement.currency.${currency}`}
                            withoutSpace
                        />
                    </GridTable.Data>
                    <GridTable.Data className="agreement-owner">
                        <TransactionInfo field="accounts.agreements.owner" value={`${owner}`} />
                    </GridTable.Data>
                    <GridTable.Data className="agreement-date">
                        <TransactionInfo field="account.agreement.expirationDay" withoutSpace>
                            <FormattedDate
                                date={
                                    // esta condicion es para retrocompatibilidad cuando el campo
                                    // usaba un valor numerico (numero de dias), en lugar de fecha
                                    typeof expirationDate !== Number
                                        ? moment(expirationDate)
                                        : moment(new Date()).add(expirationDate, "days")
                                }
                                dateFormat="DD/MM/YYYY"
                            />
                        </TransactionInfo>
                    </GridTable.Data>
                    <GridTable.Data className="agreement-destination">
                        <TransactionInfo
                            field="account.agreement.purposes"
                            i18nId={`account.agreement.purposes.${purpose}`}
                            withoutSpace
                        />
                    </GridTable.Data>
                    <GridTable.Data className="agreement-fee">
                        <TransactionInfo field="account.agreement.originationFee" value={`${commission} %`} />
                    </GridTable.Data>
                    <GridTable.Data className="agreement-rate">
                        <TransactionInfo field="account.agreement.ratePercentage" value={`${tax} %`} withoutSpace />
                    </GridTable.Data>
                </GridTable.Container>
            </GridTable>
        </>
    );
};

AgreementSummary.propTypes = {
    title: string.isRequired,
    amount: number,
    productType: string,
    number: string,
    currency: string,
    owner: string,
    expirationDate: date,
    purpose: string,
    tax: number,
    isTicket: false.isRequired,
    isDesktop: bool,
    commission: number,
    showMoreData: bool,
    setShowMoreData: func,
};

AgreementSummary.defaultProps = {
    amount: 0,
    productType: "",
    number: "",
    currency: "",
    owner: "",
    expirationDate: null,
    purpose: "",
    tax: 0,
    commission: 0,
    isDesktop: false,
    showMoreData: false,
    setShowMoreData: () => {},
};

export default resizableComponent(AgreementSummary);
